import EF from 'ef/ef';

const PageService = function () {
  this.saveProgress = function (blockView) {
    EF.module.save();
  };
};

export default new PageService();
